//
//
//
//
//
//
//
//
//
//

import vtkActor from "vtk.js/Sources/Rendering/Core/Actor";
import vtkMapper from "vtk.js/Sources/Rendering/Core/Mapper";
import vtkSphereMapper from "vtk.js/Sources/Rendering/Core/SphereMapper";
import vtkSphereSource from "vtk.js/Sources/Filters/Sources/SphereSource";
import vtkPointSource from "vtk.js/Sources/Filters/Sources/PointSource";
import vtkPixelSpaceCallbackMapper from "vtk.js/Sources/Rendering/Core/PixelSpaceCallbackMapper";
import vtkOpenGLRenderWindow from "vtk.js/Sources/Rendering/OpenGL/RenderWindow";
import vtkRenderWindow from "vtk.js/Sources/Rendering/Core/RenderWindow";
import vtkRenderWindowInteractor from "vtk.js/Sources/Rendering/Core/RenderWindowInteractor";
import vtkRenderer from "vtk.js/Sources/Rendering/Core/Renderer";
import vtkInteractorStyleTrackballCamera from "vtk.js/Sources/Interaction/Style/InteractorStyleTrackballCamera";
import vtkInteractorStyleManipulator from "vtk.js/Sources/Interaction/Style/InteractorStyleManipulator";
import vtkPreset from "vtk.js/Sources/Interaction/Style/InteractorStyleManipulator/Presets";

import vtkMouseCameraTrackballMultiRotateManipulator from "vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballMultiRotateManipulator";
import vtkMouseCameraTrackballPanManipulator from "vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballPanManipulator";
import vtkMouseCameraTrackballRollManipulator from "vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballRollManipulator";
import vtkMouseCameraTrackballRotateManipulator from "vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballRotateManipulator";
import vtkMouseCameraTrackballZoomManipulator from "vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballZoomManipulator";
import vtkMouseCameraTrackballZoomToMouseManipulator from "vtk.js/Sources/Interaction/Manipulators/MouseCameraTrackballZoomToMouseManipulator";

import vtkGestureCameraManipulator from "vtk.js/Sources/Interaction/Manipulators/GestureCameraManipulator";

import vtkPlaneSource from "vtk.js/Sources/Filters/Sources/PlaneSource";
import vtkCamera from "vtk.js/Sources/Rendering/Core/Camera";
import vtkXMLPolyDataReader from "vtk.js/Sources/IO/XML/XMLPolyDataReader";
import vtkTexture from "vtk.js/Sources/Rendering/Core/Texture";
import vtkPolyData from "vtk.js/Sources/Common/DataModel/PolyData";
import vtkTubeFilter from "vtk.js/Sources/Filters/General/TubeFilter";
import vtkMath from "vtk.js/Sources/Common/Core/Math";

import { vec3 } from "gl-matrix";

import axios from "axios";

import { CesHttpClient, Continuum } from "../CesHttpClient";

import { mapState } from "vuex";

export default {
  props: {
    vtkTabIsActive: {
      type: Boolean
    },
    plannedLogData: {
      type: Continuum,
      default: null
    },
    curtainGridC: {
      type: Continuum,
      default: null
    },
    httpClient: {
      type: CesHttpClient,
      default: null
    },
    chartDefinition: {
      type: Object,
      default: {
        charts: [],
        labels: []
      }
    }
  },
  data: function () {
    return {
      renderWindow: null,
      renderer: null,
      lineRenderer: null,
      openGLRenderWindow: null,
      interactor: null,
      interactorStyle: null,
      container: null,
      polyData: null,
      textureImage: null,
      line: null,
      lineActors: [],
      gridActors: [],
      curtainActors: [],
      sphereActors: [],
      plannedLogActors: [],
      textCtx: null,
      textCanvas: null,
      camera: null,
      geometryURL: null,
      imageURL: null,
      bounds: null,
      center: null,
      cesModel: null
    };
  },
  mounted: function () {
    this.updateProgress(1);
    this.init();
    this.resize();
    window.addEventListener("resize", this.resize);
    this.updateProgress(-1);
  },
  methods: {
    init: function () {
      if(this.isPrintConsole)console.log("init() start.");
      this.renderWindow = vtkRenderWindow.newInstance();
      this.renderer = vtkRenderer.newInstance();
      this.renderer.setBackground(0.26, 0.26, 0.26);
      this.renderWindow.addRenderer(this.renderer);

      this.openglRenderWindow = vtkOpenGLRenderWindow.newInstance();
      this.renderWindow.addView(this.openglRenderWindow);

      this.container = this.$refs["vtk-graphics-container"];
      this.openglRenderWindow.setContainer(this.container);

      this.interactor = vtkRenderWindowInteractor.newInstance();
      this.interactor.setView(this.openglRenderWindow);
      this.interactor.initialize();
      this.interactor.bindEvents(this.container);
      //this.interactor.unbindEvents();

      this.interactorStyle = vtkInteractorStyleTrackballCamera.newInstance();

      // InteractorStyleManipulaor is filtering keyboard events, but the rotation center is not working!
      //this.interactorStyle = vtkInteractorStyleManipulator.newInstance();
      //this.reassignManipulators(this.interactorStyle);

      this.interactor.setInteractorStyle(this.interactorStyle);

      this.textCanvas = this.$refs["vtk-text-container"];
      this.textCanvas.style.position = "absolute";
      this.textCtx = this.textCanvas.getContext("2d");

      this.load();

      if (!this.vtkCamera) {
        this.initCamera();
      }

      this.camera.onModified(this.setGridVisibility);

      this.renderer.setActiveCamera(this.camera);
      this.renderer.resetCamera();
      if(this.isPrintConsole)console.log("init() end.");
    },

    initCamera: function () {
      this.camera = vtkCamera.newInstance();
      this.camera.setViewUp([0, 0, 1]);
      this.camera.setPosition(0, -1, 0);
      this.camera.azimuth(37.5);
      this.camera.elevation(20);
      this.camera.setParallelProjection(true);
    },

    reassignManipulators: function (interactorStyle) {
      vtkPreset.applyPreset("3D", interactorStyle);
    },

    load: function () {
      this.updateProgress(1);
      if(this.isPrintConsole)console.log("load() start.");

      try {
        // Moved to App.vue
        // const geometry = await this.httpClient.downloadContinuumPropertyVtk(this.curtainGridC, this.selectedCurtainProperties[0],"vtk");
        // const texture = await this.httpClient.downloadContinuumPropertyVtk(this.curtainGridC, this.selectedCurtainProperties[0],"png");
        const geometry = this.geometryForVtk;
        const texture = this.textureForVtk;

        const parser = new DOMParser();
        const geometryXML = parser.parseFromString(geometry, "text/xml");
        const reader = vtkXMLPolyDataReader.newInstance();
        reader.parseXML(geometryXML);
        this.polyData = reader.getOutputData(0);

        const urlCreator = window.URL || window.webkitURL;
        const imageUrl = urlCreator.createObjectURL(texture);
        const image = new Image();
        image.onload = () => {
          this.textureImage = image;
          this.createPipeline();
        };
        image.src = imageUrl;
      } catch (e) {
        let msg = "!!! Error Failed to download Continuum Property for VTK." + e;
        console.log(msg);
      }

      if(this.isPrintConsole)console.log("load() end.");
      this.updateProgress(-1);
    },

    createPipeline: function () {
      this.updateProgress(1);

      this.curtainActors.forEach(
        function (la) {
          this.renderer.getActors().forEach(
            function (a) {
              if (la == a) {
                this.renderer.removeActor(a);
              }
            }.bind(this)
          );
        }.bind(this)
      );

      var firstCall = false;
      if (this.curtainActors.length == 0) {
        firstCall = true;
      }

      this.curtainActors = [];

      const source = this.polyData;
      const mapper = vtkMapper.newInstance();
      const actor = vtkActor.newInstance();
      const tcoords = source.getPointData().getTCoords();

      const texture = vtkTexture.newInstance();
      texture.setInterpolate(false);
      texture.setRepeat(false);
      texture.setEdgeClamp(true);
      texture.setImage(this.textureImage);
      actor.addTexture(texture);

      source
        .getPointData()
        .setActiveTCoords(tcoords ? tcoords.getName() : "TextureCoordinates");

      actor.setMapper(mapper);
      actor.getProperty().setOpacity(0.9);
      mapper.setInputData(source);

      this.renderer.addActor(actor);

      this.curtainActors.push(actor);

      if (firstCall == true) {
        this.renderer.resetCamera();
      }

      this.addLines();

      this.addGrid();

      //this.renderWindow.render();

      this.bounds = this.polyData.getBounds();
      this.center = this.getCenter(this.bounds);
      //console.log("Center of rotation = " + this.center);

      if (this.interactorStyle.isA("vtkInteractorStyleManipulator")) {
        this.interactorStyle.setCenterOfRotation(this.center);
      }

      if (this.scenarioJSON != null) {
        this.addPlannedWell();
      }
      this.renderWindow.render();

      this.updateProgress(-1);
    },

    addLines: function () {
      if (!this.logPlotData) {
        return;
      }

      this.lineActors.forEach(
        function (la) {
          this.renderer.getActors().forEach(
            function (a) {
              if (la == a) {
                this.renderer.removeActor(a);
              }
            }.bind(this)
          );
        }.bind(this)
      );

      this.lineActors = [];

      const x = this.logPlotData["X"].d;
      const y = this.logPlotData["Y"].d;
      const z = this.logPlotData["Z"].d;
      const n = x.length;
      //const zmax = this.curtainGridC.getz().last + 1000;
      //console.log(z);

      let points = [];
      let lines = [n];
      for (let i = 0; i < n; i++) {
        points.push(x[i]);
        points.push(y[i]);
        points.push(-z[i]); //zmax - z[i])
        lines.push(i);
      }

      const polyline = vtkPolyData.newInstance();
      if (this.currentFwdMDindex == null)
        polyline.getPoints().setData(Float32Array.from(points), 3);
      else {
        polyline
          .getPoints()
          .setData(
            Float32Array.from(
              points.slice(0, 3 * (this.currentFwdMDindex + 1))
            ),
            3
          );
      }
      polyline.getLines().setData(Uint32Array.from(lines));

      const polyline2 = vtkPolyData.newInstance();
      polyline2
        .getPoints()
        .setData(
          Float32Array.from(points.slice(0, 3 * (this.currentMDindex + 1))),
          3
        );
      polyline2.getLines().setData(Uint16Array.from(lines));

      const tubeFilter = vtkTubeFilter.newInstance();
      tubeFilter.setInputData(polyline);
      tubeFilter.setRadius(2);
      tubeFilter.setNumberOfSides(10);

      const tubeFilter2 = vtkTubeFilter.newInstance();
      tubeFilter2.setInputData(polyline2);
      tubeFilter2.setRadius(4);
      tubeFilter2.setNumberOfSides(10);

      const lineMapper = vtkMapper.newInstance();
      lineMapper.setInputData(tubeFilter.getOutputData());

      const lineMapper2 = vtkMapper.newInstance();
      lineMapper2.setInputData(tubeFilter2.getOutputData());

      const lineActor = vtkActor.newInstance();
      lineActor.setMapper(lineMapper);
      lineActor.getProperty().setColor(0, 0, 0);

      const lineActor2 = vtkActor.newInstance();
      lineActor2.setMapper(lineMapper2);
      lineActor2.getProperty().setColor(1, 0, 0);

      this.lineActors.push(lineActor);
      this.lineActors.push(lineActor2);

      this.renderer.addActor(lineActor);
      this.renderer.addActor(lineActor2);

      // Move focal point of camera to the drill bit position. Use it as rotation point for the camera manipulator
      const fp = [
        points[this.currentMDindex * 3],
        points[this.currentMDindex * 3 + 1],
        points[this.currentMDindex * 3 + 2]
      ];
      this.moveCameraFocalPoint(fp);

      // Needed otherwise the 3D view is not refreshed
      this.renderWindow.render();
    },

    moveCameraFocalPoint: function (fp) {
      const fpi = this.camera.getFocalPoint();
      const posi = this.camera.getPosition();

      const trans = [fp[0] - fpi[0], fp[1] - fpi[1], fp[2] - fpi[2]];
      const pos = [posi[0] + trans[0], posi[1] + trans[1], posi[2] + trans[2]];

      this.camera.setFocalPoint(fp[0], fp[1], fp[2]);
      this.camera.setPosition(pos[0], pos[1], pos[2]);
      this.camera.setPhysicalTranslation(-fp[0], -fp[1], -fp[2]);

      if (this.interactorStyle.isA("vtkInteractorStyleManipulator")) {
        this.interactorStyle.setCenterOfRotation(fp);
      }
    },

    addPlannedWell: function () {
      if (!this.plannedLogData) return;

      if (
        "cesModel" in this.scenarioJSON &&
        "plannedLog" in this.scenarioJSON.cesModel &&
        "continuum" in this.scenarioJSON.cesModel.plannedLog
      ) {
        const tag = this.scenarioJSON.cesModel.plannedLog.continuum;

        if (
          !this.plannedLogData.hasData("UTMx") ||
          !this.plannedLogData.hasData("UTMy") ||
          !this.plannedLogData.hasData("TVDMSL")
        )
          return;

        //console.log("Planned log actors length = " + this.plannedLogActors.length);

        if (this.plannedLogActors.length > 0)
          // No need to rebuild the planned well, it is fixed!
          return;

        //console.log("Adding planned log " + tag);

        const x = this.plannedLogData.getData("UTMx");
        const y = this.plannedLogData.getData("UTMy");
        const z = this.plannedLogData.getData("TVDMSL");
        const n = x.length;

        let points = [];
        let lines = [n];
        for (let i = 0; i < n; i++) {
          points.push(x[i]);
          points.push(y[i]);
          points.push(-z[i]);
          lines.push(i);
        }

        const polyline = vtkPolyData.newInstance();
        polyline.getPoints().setData(Float32Array.from(points), 3);
        polyline.getLines().setData(Uint16Array.from(lines));

        const tubeFilter = vtkTubeFilter.newInstance();
        tubeFilter.setInputData(polyline);
        tubeFilter.setRadius(3);
        tubeFilter.setNumberOfSides(10);

        const lineMapper = vtkMapper.newInstance();
        lineMapper.setInputData(tubeFilter.getOutputData());

        const lineActor = vtkActor.newInstance();
        lineActor.setMapper(lineMapper);
        lineActor.getProperty().setColor(1, 1, 0.5);

        this.plannedLogActors.push(lineActor);
        this.renderer.addActor(lineActor);
      }
    },

    addGrid: function () {
      this.gridActors.forEach(
        function (ga) {
          this.renderer.getActors().forEach(
            function (a) {
              if (ga == a) {
                this.renderer.removeActor(a);
              }
            }.bind(this)
          );
        }.bind(this)
      );

      this.gridActors = [];
      const b = this.polyData.getBounds();

      // Make sure the grid is slightly behind the actors
      b[0] = b[0] - (b[0] * 0.0001) / 100;
      b[3] = b[3] + (b[3] * 0.0001) / 100;
      this.addBoundingBox(b, [1.0, 1.0, 1.0], 5);

      /** *
        const bb = this.polyData.getBounds();

        bb[0] = bb[0] + (bb[0] * 0.0001) / 100;
        bb[1] = bb[1] - (bb[1] * 0.0002) / 100;
        bb[2] = bb[2] + (bb[2] * 0.0001) / 100;
        bb[3] = bb[3] - (bb[3] * 0.0001) / 100;
        bb[4] = bb[4] + (bb[4] * 0.001) / 100;
        bb[5] = bb[5] - (bb[5] * 0.001) / 100;
        console.log('bb='+bb)
        this.addBoundingBox(bb, [0.5,0.5,0.5], 20)
        **/
      this.gridActors[1].setVisibility(false);
      this.gridActors[2].setVisibility(false);
      this.gridActors[5].setVisibility(false);

      //this.gridActors[7].setVisibility(false);
      //this.gridActors[8].setVisibility(false);
      //this.gridActors[11].setVisibility(false);
    },
    addBoundingBox: function (b, color, resolution) {
      const origins = [
        [b[0], b[2], b[4]],
        [b[0], b[2], b[5]],
        [b[0], b[2], b[4]],
        [b[0], b[3], b[4]],
        [b[0], b[2], b[4]],
        [b[1], b[2], b[4]]
      ];
      const points1 = [
        [b[1], b[2], b[4]],
        [b[1], b[2], b[5]],
        [b[0], b[2], b[5]],
        [b[0], b[3], b[5]],
        [b[0], b[2], b[5]],
        [b[1], b[2], b[5]]
      ];
      const points2 = [
        [b[0], b[3], b[4]],
        [b[0], b[3], b[5]],
        [b[1], b[2], b[4]],
        [b[1], b[3], b[4]],
        [b[0], b[3], b[4]],
        [b[1], b[3], b[4]]
      ];
      for (let i = 0; i < origins.length; i++) {
        const plane = vtkPlaneSource.newInstance();
        plane.setXResolution(resolution);
        plane.setYResolution(resolution);
        plane.setOrigin(origins[i]);
        plane.setPoint1(points1[i]);
        plane.setPoint2(points2[i]);

        const mapper = vtkMapper.newInstance();
        mapper.setInputConnection(plane.getOutputPort());

        const actor = vtkActor.newInstance();
        actor.setMapper(mapper);
        actor.getProperty().setColor(color[0], color[1], color[2]);
        actor.getProperty().setRepresentationToWireframe();
        //actor.getProperty().setLineStipplePattern(0x1111)
        //actor.getProperty().setLineStippleRepeatFactor(1)

        this.gridActors.push(actor);
        this.renderer.addActor(actor);
      }
    },
    getCameraAzimuthAndElevation: function () {
      // This code for computing azimuth and elevation is based on this
      // answer on stackoverflow: https://stackoverflow.com/a/10974313

      if (this.center == null) {
        return;
      }

      const pos = this.camera.getPosition();
      const fp = this.camera.getFocalPoint();
      const fwd = vec3.create();
      const cam = vec3.create();
      const obj = vec3.create();
      const right = vec3.create();
      const up = vec3.create();
      const viewUp = vec3.create();
      const proj = vec3.create();

      vec3.set(fwd, fp[0], fp[1], fp[2]);
      vec3.set(cam, pos[0], pos[1], pos[2]);
      vec3.set(obj, this.center[0], this.center[1], this.center[2]);
      vec3.set(viewUp, 0, 0, 1);

      vec3.normalize(fwd, fwd);

      // translate so the camera is at (0, 0, 0)
      vec3.sub(obj, obj, cam);

      // calculate the orthonormal basis of the camera
      vec3.cross(right, fwd, viewUp);
      vec3.normalize(right, right);
      vec3.cross(up, right, fwd);

      // rotate so the camera is pointing straight down the z axis
      // (this is essentially a matrix multiplication)
      vec3.set(
        obj,
        vec3.dot(obj, right),
        vec3.dot(obj, up),
        vec3.dot(obj, fwd)
      );

      const azimuth = vtkMath.degreesFromRadians(Math.atan2(obj[0], obj[2]));

      vec3.set(proj, obj[0], 0, obj[2]);
      vec3.normalize(obj, obj);
      vec3.normalize(proj, proj);
      let elevation = vtkMath.degreesFromRadians(
        Math.acos(vec3.dot(obj, proj))
      );
      if (obj[1] < 0) {
        elevation = -elevation;
      }

      return { azimuth: azimuth, elevation: elevation };
    },
    setGridVisibility: function () {
      if (this.renderer.getActors().length == 0) {
        return;
      }

      const cam = this.getCameraAzimuthAndElevation();
      if (!cam) {
        return;
      }

      if (this.gridActors) {
        const vis = this.preferences.showGrid;

        if (cam.elevation < 0) {
          this.gridActors[0].setVisibility(vis);
          this.gridActors[1].setVisibility(false);

          //this.gridActors[6].setVisibility(vis);
          //this.gridActors[7].setVisibility(false);
        } else {
          this.gridActors[0].setVisibility(false);
          this.gridActors[1].setVisibility(vis);

          //this.gridActors[6].setVisibility(false);
          //this.gridActors[7].setVisibility(vis);
        }

        if (cam.azimuth < 0) {
          if (cam.azimuth < -4) {
            this.gridActors[4].setVisibility(vis);
            this.gridActors[5].setVisibility(false);

            //this.gridActors[10].setVisibility(vis);
            //this.gridActors[11].setVisibility(false);
          } else {
            this.gridActors[4].setVisibility(false);
            this.gridActors[5].setVisibility(vis);

            //this.gridActors[10].setVisibility(false);
            //this.gridActors[11].setVisibility(vis);
          }
          if (cam.azimuth > -94) {
            this.gridActors[2].setVisibility(false);
            this.gridActors[3].setVisibility(vis);

            //this.gridActors[8].setVisibility(false);
            //this.gridActors[9].setVisibility(vis);
          } else {
            this.gridActors[2].setVisibility(vis);
            this.gridActors[3].setVisibility(false);

            //this.gridActors[8].setVisibility(vis);
            //this.gridActors[9].setVisibility(false);
          }
        } else {
          if (cam.azimuth > 175) {
            this.gridActors[4].setVisibility(vis);
            this.gridActors[5].setVisibility(false);

            //this.gridActors[10].setVisibility(vis);
            //this.gridActors[11].setVisibility(false);
          } else {
            this.gridActors[4].setVisibility(false);
            this.gridActors[5].setVisibility(vis);

            //this.gridActors[10].setVisibility(false);
            //this.gridActors[11].setVisibility(vis);
          }
          if (cam.azimuth > 85) {
            this.gridActors[2].setVisibility(vis);
            this.gridActors[3].setVisibility(false);

            //this.gridActors[8].setVisibility(vis);
            //this.gridActors[9].setVisibility(false);
          } else {
            this.gridActors[2].setVisibility(false);
            this.gridActors[3].setVisibility(vis);

            //this.gridActors[8].setVisibility(false);
            //this.gridActors[9].setVisibility(vis);
          }
        }
      }
    },
    getCenter: function (bounds) {
      return [
        0.5 * (bounds[0] + bounds[1]),
        0.5 * (bounds[2] + bounds[3]),
        0.5 * (bounds[4] + bounds[5])
      ];
    },
    resize: function () {
      // if(this.isPrintConsole)console.log("resize() starts.");
      if (this.vtkTabIsActive) {
        const dims = this.container.getBoundingClientRect();
        var w = dims.width;
        var h = dims.height;
        //var w = window.innerWidth
        //var h = window.innerHeight
        if (w == 0 || h == 0) return;
        if (h > 1200) h = 1200;
        //console.log('w='+w+', h='+h)

        this.textCanvas.setAttribute("width", w);
        this.textCanvas.setAttribute("height", h);

        this.openglRenderWindow.setSize(w, h); //dims.width, dims.height);
        this.renderWindow.render();

        this.$emit("vtk-container-size-changed", {
          width: w, //dims.width,
          height: h //dims.height
        });
      }
      // if(this.isPrintConsole)console.log("resize() ends.");
    },
    clear: function () {
      // Not removing everything, because some parts are static!
      //this.renderer.removeAllViewProps();
    },

    update: function () {
      this.clear();
      this.load();
    },
    updateProgress: function (progress) {
      this.$store.commit("preferences/updateProgress", progress);
    },
    updateDecisionPoints: function () {
      this.sphereActors.forEach(
        function (la) {
          this.renderer.getActors().forEach(
            function (a) {
              if (la == a) {
                this.renderer.removeActor(a);
              }
            }.bind(this)
          );
        }.bind(this)
      );

      this.sphereActors = [];

      if (_.has(this.chartDefinition, "labels")) {
        const x = this.logPlotData["X"].d;
        const y = this.logPlotData["Y"].d;
        const z = this.logPlotData["Z"].d;
        const md = this.logPlotData["MD"].d;
        for (let i = 0; i < this.chartDefinition.labels.length; i++) {
          let label = this.chartDefinition.labels[i];

          //if (label.markerText.length<2)
          //  continue;

          let points = [];
          let lines = [label.markerText.length];

          for (let j = 0; j < label.markerText.length; j++) {
            let mdpos = label.posMD[j];
            const MDIndex = md.findIndex(function (el) {
              return el >= mdpos - 1e-5;
            });
            let utmX = x[MDIndex];
            let utmY = y[MDIndex];
            let dz = -z[MDIndex];
            //console.log('++++++ ' + label.markerText[j]+' utmX='+utmX+', utmY='+utmY+', z='+dz);

            points.push(x[MDIndex]);
            points.push(y[MDIndex]);
            points.push(-z[MDIndex]);
            lines.push(j);
          }

          const polyline = vtkPolyData.newInstance();

          polyline.getPoints().setData(Float32Array.from(points), 3);
          polyline.getLines().setData(Uint16Array.from(lines));

          const mapper = vtkSphereMapper.newInstance();
          mapper.setRadius(12.0);
          mapper.setInputData(polyline);

          const actor = vtkActor.newInstance();
          actor.getProperty().setOpacity(1.0);
          actor.getProperty().setColor(1, 1, 0);
          actor.setMapper(mapper);
          actor.setVisibility(true);

          const psMapper = vtkPixelSpaceCallbackMapper.newInstance();
          psMapper.setInputData(polyline);
          psMapper.setCallback(coordsList => {
            const dims = this.container.getBoundingClientRect();

            if (this.textCtx && dims) {
              this.textCtx.clearRect(0, 0, dims.width, dims.height);
              coordsList.forEach((xy, idx) => {
                this.textCtx.font = "12px serif";
                this.textCtx.textAlign = "center";
                this.textCtx.textBaseline = "bottom";
                this.textCtx.fillText(
                  label.markerText[idx] /*`DP ${idx}`*/,
                  xy[0],
                  dims.height - xy[1] - 15
                );
              });
            }
          });

          const textActor = vtkActor.newInstance();
          textActor.setMapper(psMapper);

          this.sphereActors.push(textActor);
          this.renderer.addActor(textActor);

          this.sphereActors.push(actor);
          this.renderer.addActor(actor);
        }
      }
    },
    applyPreferences: function () {
      //console.log("Applying new preferences");
      const prefs = this.preferences;
      this.sphereActors.forEach(function (act) {
        act.setVisibility(prefs.showDecisionPoints);
      });

      const dims = this.container.getBoundingClientRect();

      if (this.textCtx && dims && prefs.showDecisionPoints == false) {
        this.textCtx.clearRect(0, 0, dims.width, dims.height);
      }

      this.plannedLogActors.forEach(function (act) {
        act.setVisibility(prefs.showPlannedWell);
      });

      this.lineActors.forEach(function (act) {
        act.setVisibility(prefs.showDrilledPath);
      });

      this.setGridVisibility();
      /*   this.gridActors.forEach(function(act) {
        act.setVisibility(prefs.showGrid);
      }); */

      this.renderWindow.render();
    },
    updateBindevents: function (isBinding) {
      if (isBinding) {
        this.interactor.bindEvents(this.container);
      } else {
        this.interactor.unbindEvents();
      }
    }
  },
  computed: {
    preferences() {
      let prefs_merged = {};
      prefs_merged = Object.assign(
        {},
        this.$store.state.preferences.global,
        this.$store.state.preferences.vtk3DView
      );
      //console.log(prefs_merged);
      return prefs_merged; // store preferences using Vuex
    },
    ...mapState({
      isPrintConsole: state => state.preferences.isPrintConsole,
      scenarioJSON: state => state.preferences.scenarioJSON,
      selectedCurtainProperties: state => state.curtains.selectedCurtainProperties,
      siteComDialog: state => state.preferences.global.siteComDialog,
      logPlotData: state => state.drilling.logPlotData,
      currentMDindex: state => state.drilling.currentMDindex,
      currentFwdMDindex: state => state.drilling.currentFwdMDindex,
      lastRequestedPointers: state => state.drilling.lastRequestedPointers,
      geometryForVtk: state => state.curtains.geometryForVtk,
      textureForVtk: state => state.curtains.textureForVtk,
    })
  },
  watch: {
    logPlotData: function () {
      if(this.isPrintConsole)console.log("addLines() triggered by logPlotData change.");
      this.addLines();
    },
    currentMDindex: function () {
      if(this.isPrintConsole)console.log("addLines() triggered by currentMDindex change.");
      this.addLines();
    },
    lastRequestedPointers: function () {
      if (!this.polyData) {
        return;
      }
      if(this.isPrintConsole)console.log("update() triggered by lastRequestedPoints change.");
      this.update();
    },
    chartDefinition: {
      handler: function (val, oldVal) {
        //if (val.labels[0].markerText.length != oldVal.labels[0].markerText.length)
        if(this.isPrintConsole)console.log("updateDecisionPoints() triggered by chartDefinition change.");
        this.updateDecisionPoints();
        //this.redrawRequested = true;
      },
      deep: true
    },

    plannedLogData: {
      handler: function () {
        //console.log("Planned log data has changed");
        this.addPlannedWell();
        this.renderWindow.render();
      },
      deep: true
    },

    preferences: {
      handler: function () {
        //console.log('Preferences have changed.')
        this.applyPreferences();
      },
      deep: true
    },

    vtkTabIsActive: function () {
      // if vtk tab is active, then re-bind events including keys for vtk
      // else unbind events including keys for vtk
      this.updateBindevents(this.vtkTabIsActive);
    },

    siteComDialog: function () {
      // if siteComDialog is active, then unbind events including keys for vtk
      // else re-bind events including keys for vtk
      this.updateBindevents(!this.siteComDialog);
    }
  }
};
